module.exports = __webpack_public_path__ + "media/img/marquee/marquee-program-offices-c5dff8ee36935852faae9a1292c09a80.jpg";